import * as Yup from 'yup';

const personalInformationValidationSchema = Yup.object().shape({
  firstName: Yup.string().required('نام کوچک الزامی است!'),
  lastName: Yup.string().required('نام خانوادگی الزامی است!'),
  // phone: Yup.string()
  //   .required('شماره تلفن الزامی است!')
  //   .matches(/^[0-9\u06F0-\u06F9]+$/, 'شماره تلفن باید فقط شامل اعداد باشد!')
  //   .min(10, 'شماره تلفن باید حداقل ۱۰ رقم باشد!'),
});

export default personalInformationValidationSchema;
